__turbopack_context__.v({
  "banner": "catalog-brands-grid-module-scss-module__K69qzq__banner",
  "inner": "catalog-brands-grid-module-scss-module__K69qzq__inner",
  "item": "catalog-brands-grid-module-scss-module__K69qzq__item",
  "section": "catalog-brands-grid-module-scss-module__K69qzq__section",
});
